<template>
    <paper class="work-vehicle-info">
        <m-pane
            ref="tablePage"
            v-if="tableShow"
            class="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="config.searchTotalTitle"
            pageID="workVehicleInfo_251221"
            searchId="_workVehicleInfo"
            :currentPage="currentPage"
            @search-btn="handleSearch"
            @add-btn="handleAdd"
            @edit-btn="editBtn"
            @attachment-btn="handleAttachment"
            @approve-btn="handleApprove"
            @copy-btn="handleCopy"
            @row-db-click="rowDBclick"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
            <div slot="header-content" class="header_radio">
                <el-radio-group v-model="classify" @change="selectClassify">
                    <el-radio :label="ALLVEHICLE"></el-radio>
                    <el-radio :label="OWNVEHICLE"></el-radio>
                    <el-radio :label="LINKEDVEHICLE"></el-radio>
                    <el-radio :label="CASUALVEHICLE"></el-radio>
                </el-radio-group>
            </div>
            <div slot="table-module-btn" class="btn-box">
                <el-tooltip effect="dark" content="新增" placement="bottom" style="margin-left: 10px;" v-has="'08000401'">
                    <svg class="icon add-button" aria-hidden="true" @click="handleAdd">
                        <use xlink:href="#iconicon_newlyadd"></use>
                    </svg>
                </el-tooltip>
                <el-tooltip effect="dark" content="导出" placement="bottom" style="margin-left: 10px;" v-has="'08000402'">
                    <el-button class="export-button" size="mini" @click="handleExport">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#iconicon_import"></use>
                        </svg>
                    </el-button>
                </el-tooltip>
            </div>
            <div slot="page-module-btn">
                <span class="enable-btn" v-has="'08000404'">
                    <el-button type="primary" @click="handleEnable">启用</el-button>
                </span>
                <span class="disable-btn" v-has="'08000403'">
                    <el-button type="primary" @click="handleDisable">停用</el-button>
                </span>
            </div>
        </m-pane>
        <add-or-edit-vehicle-dialog :openAddOrEditDialog="openAddOrEditDialog"
                                    :id="id"
                                    :manage="false"
                                    :supplierCode="supplierCode"
                                    :supplierName="supplierName"
                                    :propertyNature="propertyNature"
                                    :businessType="businessType"
                                    :principalName="principalName"
                                    :copy.sync="copy"
                                    :addOrEdit.sync="addOrEdit"
                                    :approve="approve"
                                    :approvalStatus="approvalStatus"
                                    @closeDialog="closeAddOrEditDialog"
                                    @confirmDialog="confirmAddOrEditDialog">
        </add-or-edit-vehicle-dialog>
        <attachment-dialog :id="id"
                           :config="attachmentConfig"
                           :openAttachmentDialog="openAttachmentDialog"
                           @closeAttachmentDialog="closeAttachmentDialog">
        </attachment-dialog>
        <reviewTipsDialog ref="reviewTipsDialog"/>
    </paper>
</template>

<script>
import '@/styles/fonts/iconfont.js';
import config from './config.js';
import paper from '@/components/core/paper/Paper';
import mPane from '../../../../components/Panel.vue';
import { cloneDeep } from 'lodash';
import addOrEditVehicleDialog from '../../manage/keyData/tabs/vehicle/AddOrEditVehicleDialog.vue';
import { enableToLabel, enableToStatus } from '../../../../utils/statusOrLabel.js';
import { getWorkbenchVehicle, enableVehicle, disableVehicle, getLoginUser, exportVehicle, existApprovalDetail } from '../../../../api/register/vehicle.js';
import { dictWithUrl } from '@/components/lots/api';
import { ALLVEHICLE, OWNVEHICLE, LINKEDVEHICLE, CASUALVEHICLE } from '../../../../constant/constant.js';
import attachmentDialog from '../../../../components/ViewAttachmentTable.vue';
import reviewTipsDialog from '../../manage/keyData/tabs/vehicle/reviewTipsDialog.vue';
const THREE_HUNDRED = 300;
export default {
    name: 'work-vehicle-info',
    components: { attachmentDialog, mPane, paper, addOrEditVehicleDialog, reviewTipsDialog },
    data() {
        return {
            ALLVEHICLE,
            OWNVEHICLE,
            LINKEDVEHICLE,
            CASUALVEHICLE,
            classify: ALLVEHICLE,
            tableShow: false,
            businessType: '',
            propertyNature: '',
            carOwnerType: '',
            supplierCode: '',
            openAddOrEditDialog: false,
            openAttachmentDialog: false,
            addOrEdit: false,
            attachmentShow: false,
            copy: false,
            approve: false,
            rowData: {},
            dict: {},
            id: new Date().getTime() + '_',
            row: {},
            selected: [],
            searchDataLists: {},
            dataObj: {},
            currentPage: 1,
            pageNo: 1,
            pageSize: 10,
            pageTotal: 0,
            selectData: [],
            searchObj: {},
            totalData: [],
            loading: false,
            labelPosition: 'right',
            config: cloneDeep(config),
            attachmentConfig: {
                column: [
                    { prop: 'qualificationName', label: '资质名称' },
                    { prop: 'certificateBeginDate', label: '证件起始日期' },
                    { prop: 'certificateEndDate', label: '证件终止日期' }
                ],
                url: '/supplierCarInfos/attachList/',
                id: ''
            },
            approvalStatus: ''
        };
    },
    computed: {
        mipNum() {
            return this.$store.state.mipNum;
        },
        supplierName() {
            return this.$store.state.supplier.supplierNameCn;
        },
        principalName() {
            return this.$store.state.supplier.principalName;
        }
    },
    methods: {
        init() {
            if (this.classify === ALLVEHICLE) {
                this.config.table.columns = config.table.allColumns;
                this.tableShow = true;
            }
        },
        load() {},
        editBtn(data) {},
        pageChange(data) {
            this.pageNo = data;
            this.handleGetData();
        },
        sizeChange(data) {
            this.pageSize = data;
            this.handleGetData();
        },
        searchChange(data) {
            this.searchObj = data;
            this.searchObj.carOwnerType = this.carOwnerType;
            this.pageNo = 1;
            this.handleGetData();
        },
        rowDBclick(row) {
            this.id = String(row.relationId);
            this.approvalStatus = row.approvalStatus;
            this.openAddOrEditDialog = true;
        },
        handleCopy(row) {
            this.copy = true;
            this.id = String(row.relationId);
            this.openAddOrEditDialog = true;
        },
        selectClassify() {
            this.tableShow = false;
            switch (this.classify) {
            case ALLVEHICLE:
                this.carOwnerType = '';
                this.config.table.columns = config.table.allColumns;
                break;
            case OWNVEHICLE:
                this.carOwnerType = '1';
                this.config.table.columns = config.table.columns;
                break;
            case LINKEDVEHICLE:
                this.carOwnerType = '2';
                this.config.table.columns = config.table.columns;
                break;
            case CASUALVEHICLE:
                this.carOwnerType = '3';
                this.config.table.columns = config.table.columns;
                break;
            }
            setTimeout(() => {
                this.tableShow = true;
                this.$nextTick(() => {
                    this.$refs.tablePage.$refs.searchList.searchData = cloneDeep(this.searchObj)
                })
            }, 0);
            this.searchObj.carOwnerType = this.carOwnerType;
            this.pageNo = 1;
            this.handleGetData();
        },
        selectChange(data) {
            this.selected = [].concat(data);
        },
        /** 导出 **/
        handleExport() {
            this.$confirm('是否确定导出?', '导出确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                let params = {
                    supplierCode: this.supplierCode
                };
                params = { ...params, ...this.searchObj };
                exportVehicle(JSON.stringify(params)).then(res => {
                    const blob = new Blob([res], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    const objectUrl = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = objectUrl;
                    a.download = '车辆信息';
                    a.click();
                    this.$message.success('导出成功');
                });
            });
        },
        /** 点击查询 调接口，拿table数据 **/
        handleSearch() {
            this.handleGetData();
        },
        /** 新增联系人 **/
        handleAdd() {
            this.addOrEdit = true;
            this.id = '';
            this.openAddOrEditDialog = true;
        },
        handleEnable() {
            if (this.selected.some((e) => enableToStatus(e.enableFlag) === '0')) {
                this.$message.warning('勾选数据中有已启用数据');
            } else {
                this.handleBatchOperation('enable', '启用');
            }
        },
        handleDisable() {
            if (this.selected.some((e) => enableToStatus(e.enableFlag) === '1')) {
                this.$message.warning('勾选数据中有已停用数据');
            } else {
                this.handleBatchOperation('disable', '停用');
            }
        },
        /** 处理批量操作 **/
        handleBatchOperation(type, text) {
            if (this.selected.length) {
                this.$confirm('是否确定要' + text + '选择的数据?', text + '确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    const arr = [];
                    this.selected.forEach(e => {
                        arr.push(String(e.relationId));
                    });
                    switch (type) {
                    case 'enable':
                        //过滤复核不通过的数据
                        const reviewList = this.selected.filter((e) => e.reviewStatus === '30')
                        if (reviewList.length) {
                            this.$refs['reviewTipsDialog'].init(reviewList)
                            return;
                        }
                        enableVehicle(JSON.stringify(arr)).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('启用成功！');
                                this.handleGetData();
                            }
                        });
                        break;
                    case 'disable':
                        disableVehicle(JSON.stringify(arr)).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('停用成功！');
                                this.handleGetData();
                            }
                        });
                        break;
                    }
                });
            } else {
                this.$message.warning('当前没有选中的数据');
            }
        },
        handleGetData(params = { pageNo: this.pageNo, pageSize: this.pageSize }) {
            params = Object.assign(params, this.searchObj);
            getWorkbenchVehicle(JSON.stringify(params)).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data.totalCount;
                    this.totalData = res.data.list;
                    this.totalData.forEach(e => {
                        e.enableFlag = enableToLabel(e.enableFlag);
                    });
                    this.totalData = this.formatData(this.totalData);
                }
            });
        },
        handleAttachment(row) {
            this.attachmentConfig.id = String(row.relationId);
            this.openAttachmentDialog = true;
        },
        /** 审批详情 **/
        handleApprove(row) {
            existApprovalDetail(row.relationId).then(res => {
                if (res && res.code === '0') {
                    if (res.data) {
                        this.approve = true;
                        this.id = String(row.relationId);
                        this.openAddOrEditDialog = true;
                    } else {
                        this.$message.warning('当前车辆无审批记录');
                    }
                }
            });
        },
        /** 关闭查看附件弹窗 **/
        closeAttachmentDialog(data) {
            this.openAttachmentDialog = data;
            this.attachmentConfig.id = '';
        },
        closeAddOrEditDialog(data) {
            this.openAddOrEditDialog = data;
            setTimeout(() => {
                this.addOrEdit = data;
                this.copy = data;
                this.approve = data;
                this.id = new Date().getTime() + '_';
                this.approvalStatus = '';
            }, THREE_HUNDRED);
        },
        confirmAddOrEditDialog(data) {
            this.openAddOrEditDialog = data;
            setTimeout(() => {
                this.addOrEdit = data;
                this.copy = data;
                this.approve = data;
                this.id = new Date().getTime() + '_';
                this.approvalStatus = '';
                this.pageNo = 1;
                this.handleGetData();
            }, THREE_HUNDRED);
        },
        formatData(data) {
            return data.map(item => {
                item.carOwnerType = this.dict.SU_CAR_TYPE[item.carOwnerType];
                item.approvalStatus_ = this.dict.SRM_AUDIT_STATUS[item.approvalStatus];
                item.reviewStatus_ = this.dict.SRM_DRIVER_CAR_REVIEW_STATUS[item.reviewStatus];
                //复核不通过才标红
                if(item.reviewStatus === '30'){
                    item._reviewFailReasonClassName = 'red-tips'
                    item._reviewStatus_ClassName = 'red-tips'
                }
                return item;
            });
        }
    },
    mounted() {
        this.init();
        if(this.$route.query.reviewStatus && this.mipNum === 1){
            this.$store.commit('setMipNum', this.mipNum + 1);
            this.$nextTick(() => {
                try{
                    this.$refs.tablePage.$refs.searchList.searchData.reviewStatusList = [this.$route.query.reviewStatus];
                    this.searchObj.reviewStatusList = [this.$route.query.reviewStatus];
                }catch(err){}
            })
        }
        dictWithUrl('SU_CAR_TYPE,SRM_AUDIT_STATUS,SRM_DRIVER_CAR_REVIEW_STATUS').then(res => {
            this.dict = res.data;
            getLoginUser().then(res => {
                if (res && res.code === '0') {
                    this.propertyNature = res.data.propertyNature;
                    this.supplierCode = res.data.supplierCode;
                    this.businessType = res.data.businessType;
                    this.handleGetData();
                }
            });
        });
    }
};
</script>

<style lang="less">
    .work-vehicle-info {
        min-width: 1200px;
        margin: 7px;
        #mPane3 .el-table {
            height: inherit;
            min-height: calc(100vh - 195px);
            max-height: calc(100vh - 195px);
        }
        .header_radio {
            height: 30px;
            width: 100%;
        }
        .enable-btn,
        .disable-btn {
            margin-left: 10px;
        }
        .icon {
            width: 1em;
            height: 1em;
            vertical-align: -0.15em;
            fill: currentColor;
            overflow: hidden;
            cursor: pointer;
        }
        .add-button {
            font-size: 28px;
        }
        .export-button {
            .icon {
                font-size: 12px;
            }
        }
        .red-tips{
            color: red;
        }
    }
</style>
